import axios from 'axios'
import { apiObject } from './apiobject'

const user = {
  ...apiObject,
  url: '/users/users/',
  resetPassword (userId, newPassword) {
    return new Promise((resolve, reject) => {
      axios.post(`${this.url}${userId}/resetpassword/`, {password: newPassword})
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response)
        })
    })
  },
  getAPIToken (userId) {
    return new Promise((resolve, reject) => {
      axios.get(`${this.url}${userId}/token/`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response)
        })
    })
  },
  resetAPIToken (userId){
    return new Promise((resolve, reject) => {
      axios.get(`${this.url}${userId}/token/?reset=true`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response)
        })
    })
  }
}

const groups = {
  ...apiObject,
  url: '/users/groups/'
}

const roles = {
  ...apiObject,
  url: '/users/roles/',
}

const audit = {
  ...apiObject,
  url: '/users/audit/',
}

const superUser = {
  ...apiObject,
  url: '/users/admin-users/',
  resetPassword (userId, newPassword) {
    return new Promise((resolve, reject) => {
      axios.post(`${this.url}${userId}/resetpassword/`, {password: newPassword})
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response)
        })
    })
  },
}

const superOrgs = {
  ...apiObject,
  url: '/users/admin-orgs/',
  save (organizationObject) {
    return new Promise((resolve, reject) => {
      let request = (organizationObject.get('id'))
          ? axios.patch(`${this.url}${organizationObject.get('id')}/`, organizationObject,
            {
              headers: {
                  'Content-Type': 'multipart/form-data'
              },
              ignoreErrorHandle: true
            })
          : axios.post(this.url, organizationObject,
            {
              headers: {
                  'Content-Type': 'multipart/form-data'
              },
              ignoreErrorHandle: true
            })
        request.then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response)
        })
    })
  }
}

const notifications = {
  url: '/notifications/me/',
  get ({ search, ordering, pageNum = 1, count = 5, filter = {} } = {}, ignoreErrorHandle = false) {
    var paramObject = Object.assign({}, { search, ordering, page: pageNum, count }, filter)
    return new Promise((resolve, reject) => {
      axios.get(`${this.url}?ordering=-id`, {
        params: paramObject,
        ignoreErrorHandle: ignoreErrorHandle
      })
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },
  getUnread (ignoreErrorHandle = false) {
    return new Promise((resolve, reject) => {
      axios.get(`${this.url}unread/`, {
        ignoreErrorHandle: ignoreErrorHandle
      })
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },
  readAll (ignoreErrorHandle = false) {
    return new Promise((resolve, reject) => {
      axios.post(`${this.url}readall/`, {
        ignoreErrorHandle: ignoreErrorHandle
      })
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },
  read (id, ignoreErrorHandle = false) {
    return new Promise((resolve, reject) => {
      axios.post(`${this.url}${id}/read/`, {ignoreErrorHandle: ignoreErrorHandle})
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
    })
  },
}

const client_messages = {
  ...notifications,
  url: '/notifications/client/',
  send (obj) {
    return new Promise((resolve, reject) => {
      axios.post(`${this.url}send/`, obj)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  user,
  groups,
  roles,
  client_messages,
  superUser,
  superOrgs,
  notifications,
  audit
}
